import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'react-loading-skeleton/dist/skeleton.css'
import reportWebVitals from './reportWebVitals';
import { requestPermission } from "./firebase";
import { set,get } from 'idb-keyval';
// import App from './containers/App';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import swDev from './swDev';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './components/common/ErrorFallback';
import { lazy } from 'react';
import { Suspense } from 'react';
import Spinner from './components/common/Spinner';
const App = lazy(() => import('./containers/App'))
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Suspense fallback={<Spinner/>}>
          <App />
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
swDev();


async function registerServiceWorkerAndSync() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
      console.log("Service Worker registered:", registration);

      await navigator.serviceWorker.ready;

      const authToken = localStorage.getItem("token");
      const fcmToken = await requestPermission(registration);

      if (authToken && fcmToken) {
        // Store tokens in IndexedDB for service worker to access
        await set("auth_token", authToken);
        await set("fcm_token", fcmToken);

        // Try immediate sync first
        try {
          const res = await fetch("https://monitoringapi.nanolog.ir/api/User/UpdateFCMToken", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify({ fcmToken }),
          });

          if (!res.ok) throw new Error("Sync failed");

          console.log("[Main] Token synced immediately");
        } catch (err) {
          console.warn("[Main] Sync failed, registering background sync:", err);
          if ("sync" in registration) {
            await registration.sync.register("sync-fcm-token");
            console.log("[Main] Background sync registered");
          }
        }
      }
    } catch (error) {
      console.error("Error during service worker registration or FCM setup:", error);
    }
  });
}

async function syncFcmTokenManually() {
  const authToken = await get("auth_token");
  const fcmToken = await get("fcm_token");
  if (!authToken || !fcmToken) return;

  try {
    const res = await fetch("https://monitoringapi.nanolog.ir/api/User/UpdateFCMToken", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({ fcmToken }),
    });

    if (!res.ok) throw new Error("Bad response");
    console.log("[Online] FCM token synced!");
  } catch (err) {
    console.warn("[Online] Sync failed again, trying background sync");
    const registration = await navigator.serviceWorker.ready;
    if ("sync" in registration) {
      await registration.sync.register("sync-fcm-token");
      console.log("Background sync registered");
    }
  }
}

registerServiceWorkerAndSync();

// Add online listener
window.addEventListener("online", () => {
  console.log("[Network] Back online");
  syncFcmTokenManually();
});

